import { createAction } from '@ngrx/store';

export enum EnquiryConfigurationActionTypes {
  Init = '[Enquiry Configuration Page] Initialised',
}

export const EnquiryConfigurationActions = {
  init: createAction(EnquiryConfigurationActionTypes.Init),
};
